const DECIMAL_INPUT_RE = /^-?\d*([.,]\d*)?$/;

/** Число для расчётов */
export const toNumberValue = (value, fallback = 0) => {
  if (value === null || value === undefined || value === "") return fallback;
  const n = Number(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : fallback;
};

/**
 * Безопасное значение для numeric input.
 * Допускает промежуточный ввод «12.», «-», «»; невалидное → fallback.
 */
export const toNumberInputValue = (value, fallback = "") => {
  if (value === null || value === undefined) return fallback;
  if (value === "") return "";

  const str = String(value).trim().replace(",", ".");
  if (DECIMAL_INPUT_RE.test(str)) return str;

  const n = Number(str);
  return Number.isFinite(n) ? String(n) : fallback;
};

export const normalizeDecimalInput = (value) =>
  String(value ?? "").replace(",", ".");
